import { reduxType } from "../../interfaces/reducerType"
const defaultState: Boolean = false;
function reducer(state = defaultState, {type, payload }: reduxType) {
    switch (type) {
        case "setMoviiLoadings":
            return payload
        default:
            return state;    
    }
}
export default reducer;